import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: [0],
    label: "Menu",
    isTitle: true,
  },
  {
    id: [2],
    label: "SET1.MENUBAR.CALENDAR.TEXT",
    icon: "bx-calendar",
    link: "calendar",
  },
  { 
    id: [0],
    label: 'DashboardsMod.DefaultComp.Menu',
    link: "dashboard",
    icon: "bx-home-circle",
  },
  
 


  // {
  //   id: 6,
  //   label: "New Sale",
  //   icon: "bx-user",
  //   parentId: 3,
  //   subItems: [
  //     {
  //       id: 216,
  //       label: "checkout",
  //       parentId: 3,
  //       link: "/sale/checkout",
  //     },
  //     {
  //       id: 222,
  //       label: "membership",
  //       parentId: 3,
  //       link: "/sale/membership",
  //     },
  //     {
  //       id: 217,
  //       label: "products",
  //       parentId: 3,
  //       link: "/sale/products",
  //     },
  //     {
  //       id: 218,
  //       label: "services",
  //       parentId: 3,
  //       link: "/sale/services",
  //     },
  //     {
  //       id: 219,
  //       label: "vouchers",
  //       parentId: 3,
  //       link: "/sale/vouchers",
  //     },
  //   ],
  // },

  {
    id: [3],
    label: "SET1.MENUBAR.CLIENTS.TEXT",
    icon: "bx-user",
    subItems: [
      {
        id: [3],
        label: "SET1.MENUBAR.CLIENTS.TEXT1",
        parentId: 2,
        link: "/clients/list",
      },
        {
          id: [3],
          label: "SET1.MENUBAR.CLIENTS.TEXT2",
          parentId: 1,
          link: "/clients/client-Notification",
        },
        {
          id: [3],
          label: "SET1.MENUBAR.CLIENTS.TEXT3",
          parentId: 1,
          link: "/clients/refral-sourse",
        },
        {
          id: [3],
          label: "SET1.MENUBAR.CLIENTS.TEXT4",
          parentId: 1,
          link: "/clients/cancel-reasons",
        },
    
    ],
  },
  {
    id: [4,5],
    label: "SET2.MENUITEMS.PRODUCT.TEXT",
    icon: "bx-purchase-tag",
    subItems: [
      // {
      //   id: 21,
      //   label: "Services",
      //   parentId: 2,
      //   subItems: [
      //     {
      //       id: 211,
      //       label: "Service Menu",
      //       parentId: 21,
      //       link: "/services",
      //     },
      //     {
      //       id: 212,
      //       label: "Vouchers",
      //       parentId: 21,
      //       link: "/services/vouchertype",
      //     },
      //     {
      //       id: 213,
      //       label: "Memberships",
      //       parentId: 21,
      //       link: "/services/memberships",
      //     },
      //     {
      //       id: 214,
      //       label: "Voucher Settings",
      //       parentId: 21,
      //       link: "/services/voucher-settings",
      //     },
      //   ],
      // },

      {
        id: [4],
        label: "SET2.MENUITEMS.PRODUCT.PRODUCT_MANAGEMENT.TEXT",
        parentId: 2,
        subItems: [
          {
            id: [4],
            label: "SET2.MENUITEMS.PRODUCT.PRODUCT_MANAGEMENT.SUBITEM1",
            parentId: 21,
            link: "/products/list",
          },
          {
            id: [4],
            label: "SET2.MENUITEMS.PRODUCT.PRODUCT_MANAGEMENT.SUBITEM2",
            parentId: 21,
            link: "/products/categories",
          },
          {
            id: [4],
            label: "SET2.MENUITEMS.PRODUCT.PRODUCT_MANAGEMENT.SUBITEM3",
            parentId: 21,
            link: "/products/brands",
          },
        ],
      },
      {
        id: [5],
        label: "SET2.MENUITEMS.PRODUCT.INVENTORY_MANAGEMENT.TEXT",
        parentId: 2,
        subItems: [
          {
            id: [5],
            label: "SET2.MENUITEMS.PRODUCT.INVENTORY_MANAGEMENT.SUBITEM1",
            parentId: 21,
            link: "/products/suppliers",
          },
          {
            id: [5],
            label: "SET2.MENUITEMS.PRODUCT.INVENTORY_MANAGEMENT.SUBITEM2",
            parentId: 21,
            link: "/products/purchase-orders",
          },
          {
            id: [5],
            label: "SET2.MENUITEMS.PRODUCT.INVENTORY_MANAGEMENT.SUBITEM3",
            parentId: 21,
            link: "/products/stock-takes",
          },
          {
            id: [5],
            label: "SET2.MENUITEMS.PRODUCT.INVENTORY_MANAGEMENT.SUBITEM4",
            parentId: 21,
            link: "/products/stock-on-hand",
          },
        ],
      },
    ],
  },
  {
    id: [-1],
    label: 'TeamsMod.Menu',
    icon:'bx-group',
    subItems: [
      {
        id: [16],
        label: 'TeamsMod.TeamMemberComp.Title',
        parentId: 22,
        link: "/teams/team-member",
      }, 
      {
        id: [16],
        label: 'TeamsMod.workinghrsComp.Title',
        parentId: 22,
        link: "/teams/working-hours",
      },
      // {
      //   id: 217,
      //   label: "Permission",
      //   parentId: 22,
      //   link: "/teams/permission",
      // },
      {
        id: [16],
        label: 'TeamsMod.AddCommissionComp.Menu',
        parentId: 22,
        link: "/teams/commission",
      },
    ],
  },
  {
    id: [17],
    label: "SET2.MENUITEMS.RESOURCE.TEXT",
    icon: 'bx bx-package',
    subItems: [
      {
        id: [17],
        label: "SET2.MENUITEMS.RESOURCE.ITEM1",
        parentId: 24,
        link: "/resource/resource-management",
      },
      {
        id: [17],
        label: "SET2.MENUITEMS.RESOURCE.ITEM2",
        parentId: 24,
        link: "/resource/resourceCategory",
      },
      {
        id: [17],
        label: "SET2.MENUITEMS.RESOURCE.ITEM3",
        parentId: 24,
        link: "/resource/working-hours",
      },
     
    ],
  },
  {
    id: [15],
    label: "SET2.MENUITEMS.SERVICES.TEXT",
    icon: 'bx-table',
    subItems: [
      {
        id: [15],
        label: "SET2.MENUITEMS.SERVICES.ITEM1",
        parentId: 21,
        link: "/services",
      },
     
      {
        id: [15],
        label: "SET2.MENUITEMS.SERVICES.ITEM2",
        parentId: 21,
        link: "/services/memberships",
      },
      {
        id: [15],
        label: "SET2.MENUITEMS.SERVICES.ITEM3",
        parentId: 21,
        link: "/services/serviceavailable",
      },
     
      {
        id: [15],
        label: "SET2.MENUITEMS.SERVICES.ITEM4",
        parentId: 21,
        link: "/services/treatmentType",
      },
      
    ],
  },

  {
    id: [6],
    label: "SET2.MENUITEMS.PROMOTE.TEXT",
    icon: "bx bxs-offer",
    subItems: [
      {
        id: [6],
        label: "SET2.MENUITEMS.PROMOTE.ITEM1",
        parentId: 2,
        link: "promote/deals",
      },
      {
        id: [6],
        label: "SET2.MENUITEMS.PROMOTE.ITEM2",
        parentId: 21,
        link: "/services/vouchers",
      },
      {
        id: [6],
        label: "SET2.MENUITEMS.PROMOTE.ITEM3",
        parentId: 21,
        link: "/services/voucherSetting",
      },
    ],
  },
  {
    id: [7,8,9,10,11,12,13],
    label: "Reports",
    icon: "bx-file",
    subItems: [
      {
        id: [7],
        label: "Finances",
        parentId: 23,
        subItems: [
          {
            id: [7],
            label: "Transaction Summary",
            parentId: 216,
            link: "/reports/finances/transaction-summary",
          },
          // {
          //   id: 223,
          //   label: "Finances Summary",
          //   parentId: 216,
          //   link: "/reports/finances/finances-summary",
          // },
          {
            id: [7],
            label: "Payments Summary",
            parentId: 216,
            link: "/reports/finances/payments-summary",
          },
          {
            id: [7],
            label: "Tips Collected",
            parentId: 222,
            link: "/reports/finances/tips-collected",
          },
          {
            id: [7],
            label: "Taxes Summary",
            parentId: 216,
            link: "/reports/finances/taxes-summary",
          },
          {
            id: [7],
            label: 'SaleMod.OrderReturnsComp.Title',
            parentId: 5,
            link: "/sales/refunds",
          },
          // {
          //   id: 226,
          //   label: "Discount Summary",
          //   parentId: 216,
          //   link: "/reports/finances/discount-summary",
          // },
          // {
          //   id: 227,
          //   label: "Outstanding Invoices",
          //   parentId: 216,
          //   link: "/reports/finances/outstanding-invoices",
          // },
        ],
      },

      {
        id: [8],
        label: 'SalesMod.Menu',
        parentId: 23,
        subItems: [
          {
            id: [8],
            label: "Daily Sales",
            parentId: 5,
            link: "/sales/dailySales",
          },
         
          {
            id: [8],
            label: "Sales History",
            parentId: 5,
            link: "/sales/sales-history",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByItemComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-item",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByTypeComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-type",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByServiceComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-service",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByProductComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-product",
          },
          {
            id: [8],
            label:  'SalesMod.SalesByLocationComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-location",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByChannelComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-channel",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByClientComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-client",
          },
          // {
          //   id: 224,
          //   label: "Sales By Team Member Breakdown",
          //   parentId: 216,
          //   link: "/reports/reportsales/sales-by-TMB",
          // },
          {
            id: [8],
            label: 'SalesMod.SalesByTMComponent.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-TM",
          },
          {
            id: [8],
            label: 'SalesMod.SalesByHourComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-hour",
          },
          // {
          //   id: 224,
          //   label: "Sales By Hour Of Day",
          //   parentId: 216,
          //   link: "/reports/reportsales/sales-by-HOD",
          // },
          {
            id: [8],
            label:  'SalesMod.SalesByDayComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-day",
          },
          {
            id: [8],
            label: 'SalesMod.SaleaByMonthComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-month",
          },
          // {
          //   id: 224,
          //   label: "Sales By Quarter",
          //   parentId: 216,
          //   link: "/reports/reportsales/sales-by-quarter",
          // },
          {
            id: [8],
            label:  'SalesMod.SalesByYearComp.Title',
            parentId: 216,
            link: "/reports/reportsales/sales-by-year",
          },
          // {
          //   id: 224,
          //   label: "Sales By Log",
          //   parentId: 216,
          //   link: "/reports/reportsales/sales-by-log",
          // },
        ],
      },
      {
        id: [9],
        label: "Inventory",
        parentId: 23,
        subItems: [
          {
            id: [9],
            label: "Stock On Hand",
            parentId: 216,
            link: "/reports/inventory/stock-on-hand",
          },
          {
            id: [9],
            label: "Product Sales Performance",
            parentId: 216,
            link: "/reports/inventory/product-sales-performance",
          },
          {
            id: [9],
            label: "Stock Movement Log",
            parentId: 216,
            link: "/reports/inventory/stock-movement-log",
          },
          {
            id: [9],
            label: "Stock Movement Summary",
            parentId: 216,
            link: "/reports/inventory/stock-movement-summary",
          },
          // {
          //   id: 227,
          //   label: "Product Consumption",
          //   parentId: 216,
          //   link: "/reports/inventory/product-consumption",
          // },
        ],
      },
      {
        id: [10],
        label: "Appointments",
        parentId: 23,
        subItems: [
          {
            id: [10],
            label: "List",
            parentId: 219,
            link: "/reports/appointments/list",
          },
          {
            id: [10],
            label: "Summary",
            parentId: 219,
            link: "/reports/appointments/summary",
          },
          {
            id: [10],
            label: "Cancellations",
            parentId: 219,
            link: "/reports/appointments/cancellations",
          },
        ],
      },
       {
        id: [19],
        label: 'SaleMod.VoucherComp.Menu',
        parentId: 23,
        subItems: [
          {
          id: [19],
          label: 'SaleMod.VoucherComp.Title',
          parentId: 5,
          link: "/sales/vouchers",
        },
      ]
    },
      // {
      //   id: 220,
      //   label: "Vouchers",
      //   parentId: 23,
      //   subItems: [
      //     {
      //       id: 223,
      //       label: "Outstanding Balance",
      //       parentId: 219,
      //       link: "/reports/voucher/outstanding-balance",
      //     },
      //     {
      //       id: 224,
      //       label: "Sales",
      //       parentId: 219,
      //       link: "/reports/voucher/sales",
      //     },
      //     {
      //       id: 225,
      //       label: "Redemptions",
      //       parentId: 219,
      //       link: "/reports/voucher/redemptions",
      //     },
      //   ],
      // },
      {
        id: [11],
        label: "Clients",
        parentId: 23,
        subItems: [
          {
            id: [11],
            label: "List",
            parentId: 219,
            link: "/reports/clients/list",
          },
          {
            id: [11],
            label: "Retention",
            parentId: 219,
            link: "/reports/clients/retention",
          },
        ],
      },
      // {
      //   id: 221,
      //   label: "Deposits",
      //   parentId: 23,
      //   subItems: [
      //     {
      //       id: 221,
      //       label: "Deposits Outstanding Balance",
      //       parentId: 23,
      //       link: "/reports/deposits/depositsOB",
      //     },
      //     {
      //       id: 221,
      //       label: "Deposits Activity",
      //       parentId: 23,
      //       link: "/reports/deposits/depositsActivity",
      //     },
      //   ],
      // },
      {
        id: [12],
        label: "Team",
        parentId: 23,
        link: "/reports/team",
        subItems: [
          {
            id: [12],
            label: "Working Hours",
            parentId: 222,
            link: "/reports/teams/working-hours",
          },
          {
            id: [12],
            label: "Tips Of Team Member",
            parentId: 222,
            link: "/reports/teams/tips-of-team-member",
          },
          // {
          //   id: [12],
          //   label: "Commission Summary",
          //   parentId: 222,
          //   link: "/reports/teams/commission-summary",
          // },
          {
            id: [12],
            label: "Commission Detailed",
            parentId: 222,
            link: "/reports/teams/commission-detailed",
          },
        ],
      },
      {
        id: [13],
        label: 'ReportsMod.DashboardComp.Title',
        parentId: 23,
        link: "/reports/dashboard",
      },
    ],
  },

  {
    id: [14],
    label: "Settings",
    icon: "bx-cog",
    subItems: [
      {
        id: [14],
        label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT",
        parentId: 2,
        icon: "bx-user",
        subItems: [
          {
            id: [14],
            label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT1",
            parentId: 4,
            link: "/accountsetup/location",
          },
          {
            id: [-1],
            label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT2",
            parentId: 4,
            link: "/accountsetup/business-detalis",
          },
          {
            id: [-1],
            label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT3",
            parentId: 4,
            link: "/accountsetup/billing-detalis",
          },
          // {
          //   id: 220,
          //   label: "Card Details",
          //   parentId: 4,
          //   link: "/accountsetup/card-detalis",
          // },
          // {
          //   id: [14],
          //   label: "Bank Accounts",
          //   parentId: 4,
          //   link: "/accountsetup/bank-account",
          // },
          {
            id: [-1],
            label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT4",
            parentId: 4,
            link: "/accountsetup/online-booking",
          },
          // {
          //   id: 223,
          //   label: "Room/Resource",
          //   parentId: 4,
          //   link: "/accountsetup/resources",
          // },
          {
            id: [14],
            label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT5",
            parentId: 4,
            link: "/accountsetup/close-dates",
          },
          {
            id: [14],
            label: "SET1.MENUBAR.ACCOUNT_SETUP.TEXT6",
            parentId: 4,
            link: "/accountsetup/departments",
          },
        ],
      },
    

     
      {
        id: [1],
        label: "Sales",
        parentId: 2,
        subItems: [
          {
            id: [1],
            label: "Invoice sequencing",
            parentId: 24,
            link: "/sales/invoice-sequencing",
          },
          // {
          //   id: [1],
          //   label: "Invoice templete",
          //   parentId: 24,
          //   link: "/sales/invoice-template",
          // },
          {
            id: [1],
            label: "Taxes",
            parentId: 24,
            link: "/sales/taxes",
          },
          {
            id: [1],
            label: "Tips",
            parentId: 24,
            link: "/sales/tips",
          },
          {
            id: [1],
            label: "Payment Type",
            parentId: 24,
            link: "/sales/payment-type",
          },
         

          // {
          //   id: 219,
          //   label: "Sales-History",
          //   parentId: 24,
          //   link: "/sales/sales-history",
          // },
          
          // {
          //   id: 222,
          //   label: "Vouchers",
          //   parentId: 24,
          //   link: "/sales/vouchers",
          // },
          // {
          //   id: 223,
          //   label: "Memberships",
          //   parentId: 24,
          //   link: "/sales/memberships",
          // },
          // {
          //   id: 224,
          //   label: "Demo",
          //   parentId: 24,
          //   link: "/sales/demo",
          // },
          
        ],
      },
    {
      id: [14],
        label: 'SET1.MENUBAR.DEVICE.TEXT',
        parentId: 4,
        link: "/devices",
    }
    ],
  },
];
//1- sale, 2- appointment, 3-client management, 4- product management, 5- inventory management, 6- deals, 7- finances report, 8- sales report , 9- inventory report , 10- appointment report, 11 - clients report, 12- teams report, 13 - report dashboard  , 14 - account setup , 15- services settings, 16- team management , 17- resources management 18- refunds 19- loyalty report 